<div class="container">
    <div class="message-box">
        <p>{{message | translate}}</p>
    </div>
    <div class="action-buttons">
        <button class="button" (click)="close('cancel')">{{'cancel' | translate}}</button>
        <button class="button" (click)="close('ok')">{{'ok' | translate}}</button>
    </div>
</div>